import HierarchyProfileContainer from './hierarchy_profile_container';

const HierarchyProfile = HierarchyProfileContainer;

export default HierarchyProfile;
